import script from "./CreateList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateList.vue?vue&type=script&setup=true&lang=ts"

import "./CreateList.vue?vue&type=style&index=0&id=7ffbc3ed&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ffbc3ed"]])

export default __exports__